import type { Sortable, UniversallyUniqueId } from '../common'
import type { BLOCK_TYPE } from '../enums'

import type { BlockBaseSettings, IBlock } from './base'

export type ConsentItemId = UniversallyUniqueId

export enum CONSENT_TOPIC {
  GTC = 'gtc',
  DATA_PRIVACY = 'data-privacy',
  CANCELLATION_POLICY = 'cancellation-policy',
  EMAIL_MARKETING = 'email-marketing',
  SMS_MARKETING = 'sms-marketing',
  PHONE_CALL_MARKETING = 'phone-call-marketing',
  PRINT_MARKETING = 'print-marketing'
}

export interface ConsentItem extends Sortable {
  /**
   * Determines whether the user is obliged to give their consent.
   */
  required: boolean
  /**
   * Which topics this consent relates with.
   */
  topics: (CONSENT_TOPIC | string)[]
  /**
   * Render text in markdown format.
   */
  text?: string | null
}

export interface ConsentsBlock extends IBlock {
  type: BLOCK_TYPE.HYPERLINK
  required: false // can't ever be required
  settings: BlockBaseSettings & {
    /** Map of consents */
    items: Record<ConsentItemId, ConsentItem>
  }
}
